// A deploy replaces the hashed page chunks. A tab opened before it still asks for
// the old ones, and the browser reports that as one of these errors. Reloading
// fetches the new build, so we reload — but only once in a while, so a chunk that
// is genuinely missing never traps the user in a reload loop.

const CHUNK_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /unable to preload css/i,
];

export const RELOAD_WINDOW_MS = 10 * 60 * 1000;

export function isChunkLoadError(error) {
  if (!error) return false;
  if (error.name === "ChunkLoadError") return true;
  const message = String(error.message ?? error);
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

/** True unless we already reloaded for a new build within the window. */
export function shouldReloadForNewBuild(lastReloadAt, now, windowMs = RELOAD_WINDOW_MS) {
  return !lastReloadAt || now - lastReloadAt > windowMs;
}
